'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAsterisk = function IoAsterisk(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 17.5v5l-14.5-0.8 8.1 13.3-4.4 2.5-6.7-13.7-6.7 13.7-4.4-2.5 8.1-13.3-14.5 0.8v-5l14.6 0.5-8.5-13 4.7-2.5 6.7 13.8 6.7-13.8 4.7 2.5-8.5 13z' })
        )
    );
};

exports.default = IoAsterisk;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/asterisk.js
// module id = 2436
// module chunks = 168707334958949